import arrayHelpers from "./arrayHelpers";
import dateHelpers from "./dateHelpers";

const schedulingHelpers = {
  defaultWorkHours: () => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return days
      .filter((x) => x !== "Sunday" && x !== "Saturday")
      .map((x) => days.indexOf(x))
      .reduce((map, obj) => {
        map[obj] = [{ start: "8:00 AM", end: "5:00 PM" }];
        return map;
      }, {});
  },

  getAvailableDaysAgents: (agents, totalDays, isNextWeek) => {
    let lastDayOfWeek = new Date().getDate() - (new Date().getDay() - 1) + 6;
    const lastDateOfWeek = !isNextWeek
      ? new Date(new Date().setDate(lastDayOfWeek))
      : dateHelpers.addDays(1, new Date(new Date().setDate(lastDayOfWeek)));
    let todayDay = new Date().getDay();
    let retDays = [];

    agents.forEach((x) => {
      let days = Object.keys(x.workHours.data); //.filter(x => parseInt(x) !== todayDay);
      let upcomingDays = [];
      if (!isNextWeek) {
        upcomingDays = days.map((n) => dateHelpers.addDays(n < todayDay ? n - todayDay + 7 : n - todayDay));
        upcomingDays = upcomingDays.filter((x) => x <= lastDateOfWeek);
      } else {
        for (let i = 0; i < days.length; i++) {
          const day = parseInt(days[i]) === 0 ? 7 : parseInt(days[i]);
          let date = dateHelpers.addDays(day - 1, new Date(lastDateOfWeek));

          if (days.filter((x) => parseInt(x) === date.getDay()).length > 0) upcomingDays.push(date);
        }
      }

      for (const upcomingDay of upcomingDays) {
        let datePrefix = `${upcomingDay.getMonth() + 1}/${upcomingDay.getDate()}/${upcomingDay.getFullYear()}`;
        let startPrefix = x.workHours.data[upcomingDay.getDay()][0].start;
        let endPrefix = x.workHours.data[upcomingDay.getDay()][0].end;

        let startDate = new Date(
          Date.parse(`${datePrefix} ${startPrefix}`) - Number(x.gmtOffset) * 60 * 60 * 1000 + dateHelpers.getTimeZoneOffset() * 60 * 60 * 1000
        );
        let endDate = new Date(
          Date.parse(`${datePrefix} ${endPrefix}`) - Number(x.gmtOffset) * 60 * 60 * 1000 + dateHelpers.getTimeZoneOffset() * 60 * 60 * 1000
        );

        if (
          !retDays.some(
            (x) =>
              `${x.getMonth() + 1}/${x.getDate()}/${x.getFullYear()}` ===
              `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}`
          )
        )
          retDays.push(startDate);

        if (
          !retDays.some(
            (x) =>
              `${x.getMonth() + 1}/${x.getDate()}/${x.getFullYear()}` === `${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()}`
          )
        )
          retDays.push(endDate);
      }
    });

    retDays = !isNextWeek ? retDays.filter((x) => x.getDay() != todayDay) : retDays;
    retDays = arrayHelpers.sortArrayOfDates(retDays);

    return !isNextWeek ? retDays.splice(0, totalDays) : retDays;
  },

  getAvailableDays: (workHours, totalDays, agentGmtOffset, isNextWeek) => {
    let lastDayOfWeek = new Date().getDate() - (new Date().getDay() - 1) + 6;
    const lastDateOfWeek = !isNextWeek
      ? new Date(new Date().setDate(lastDayOfWeek))
      : dateHelpers.addDays(1, new Date(new Date().setDate(lastDayOfWeek)));

    let todayDay = new Date().getDay();
    let workDays = Object.keys(workHours);
    let upcomingDays = [];
    if (!isNextWeek) {
      upcomingDays = workDays.map((n) => dateHelpers.addDays(n < todayDay ? n - todayDay + 7 : n - todayDay));
      upcomingDays = upcomingDays.filter((x) => x <= lastDateOfWeek);
    } else {
      for (let i = 0; i < workDays.length; i++) {
        const day = parseInt(workDays[i]) === 0 ? 7 : parseInt(workDays[i]);
        let date = dateHelpers.addDays(day - 1, new Date(lastDateOfWeek));

        if (workDays.filter((x) => parseInt(x) === date.getDay()).length > 0) upcomingDays.push(date);
      }
    }

    let retDays = [];
    for (const upcomingDay of upcomingDays) {
      let datePrefix = `${upcomingDay.getMonth() + 1}/${upcomingDay.getDate()}/${upcomingDay.getFullYear()}`;
      let startPrefix = workHours[upcomingDay.getDay()][0].start;
      let endPrefix = workHours[upcomingDay.getDay()][0].end;

      let startDate = new Date(
        Date.parse(`${datePrefix} ${startPrefix}`) - Number(agentGmtOffset) * 60 * 60 * 1000 + dateHelpers.getTimeZoneOffset() * 60 * 60 * 1000
      );
      let endDate = new Date(
        Date.parse(`${datePrefix} ${endPrefix}`) - Number(agentGmtOffset) * 60 * 60 * 1000 + dateHelpers.getTimeZoneOffset() * 60 * 60 * 1000
      );

      if (
        !retDays.some(
          (x) =>
            `${x.getMonth() + 1}/${x.getDate()}/${x.getFullYear()}` ===
            `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}`
        )
      )
        retDays.push(startDate);

      if (
        !retDays.some(
          (x) => `${x.getMonth() + 1}/${x.getDate()}/${x.getFullYear()}` === `${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()}`
        )
      )
        retDays.push(endDate);
    }

    retDays = !isNextWeek ? retDays.filter((x) => x.getDay() != todayDay) : retDays;
    retDays = arrayHelpers.sortArrayOfDates(retDays);

    return !isNextWeek ? retDays.splice(0, totalDays) : retDays;
  },

  getAvailableDaysForBreakdown: (workHours, totalDays, isNextWeek) => {
    let lastDayOfWeek = new Date().getDate() - (new Date().getDay() - 1) + 6;
    const lastDateOfWeek = !isNextWeek
      ? new Date(new Date().setDate(lastDayOfWeek))
      : dateHelpers.addDays(1, new Date(new Date().setDate(lastDayOfWeek)));
    let todayDay = new Date().getDay();
    let workDays = Object.keys(workHours);
    let upcomingDays = [];
    if (!isNextWeek) {
      upcomingDays = workDays.map((n) => dateHelpers.addDays(n < todayDay ? n - todayDay + 7 : n - todayDay));
      upcomingDays = upcomingDays.filter((x) => x <= lastDateOfWeek);
    } else {
      for (let i = 0; i < workDays.length; i++) {
        const day = parseInt(workDays[i]) === 0 ? 7 : parseInt(workDays[i]);
        let date = dateHelpers.addDays(day - 1, new Date(lastDateOfWeek));

        if (workDays.filter((x) => parseInt(x) === date.getDay()).length > 0) upcomingDays.push(date);
      }
    }
    upcomingDays = arrayHelpers.sortArrayOfDates(upcomingDays);

    return !isNextWeek ? upcomingDays.splice(0, totalDays) : upcomingDays;
  },

  getSchedulingBreakdown: (workHours, agentGmtOffset, isNextWeek) => {
    let availableDays = schedulingHelpers.getAvailableDaysForBreakdown(workHours.data, 7, isNextWeek);
    let agentAvailableSchedule = [];
    for (const currDate of availableDays) {
      let datePrefix = `${currDate.getMonth() + 1}/${currDate.getDate()}/${currDate.getFullYear()}`;

      // If there exists a startDate / endDate in the currentDay array then only consider that and nothing else.

      // eslint-disable-next-line no-labels
      date_schedule: if (workHours.data[currDate.getDay()].some((x) => x.startDate && x.endDate && x.startDate > 0 && x.endDate > 0)) {
        let workHour = workHours.data[currDate.getDay()].filter((x) => x.startDate && x.endDate && x.startDate > 0 && x.endDate > 0)[0];
        let startPrefix = workHour.start;
        let endPrefix = workHour.end;

        currDate.setHours(0, 0, 0, 0);
        const startDt = new Date(workHour.startDate * 1000);
        startDt.setHours(0, 0, 0, 0);
        const endDt = new Date(workHour.endDate * 1000);
        endDt.setHours(0, 0, 0, 0);
        if (currDate < startDt || currDate > endDt) {
          // eslint-disable-next-line no-labels
          break date_schedule;
        }

        agentAvailableSchedule.push({
          agentStartDate: new Date(Date.parse(`${datePrefix} ${startPrefix}`)),
          agentEndDate: new Date(Date.parse(`${datePrefix} ${endPrefix}`)),
        });

        continue;
      }

      for (let i = 0; i < workHours.data[currDate.getDay()].length; i++) {
        const workHour = workHours.data[currDate.getDay()][i];
        let startPrefix = workHour.start;
        let endPrefix = workHour.end;

        // If the start and end dates are defined and the current date does not l
        if (workHour.startDate && workHour.startDate !== 0 && workHour.endDate && workHour.endDate !== 0) {
          currDate.setHours(0, 0, 0, 0);
          const startDt = new Date(workHour.startDate * 1000);
          startDt.setHours(0, 0, 0, 0);
          const endDt = new Date(workHour.endDate * 1000);
          endDt.setHours(0, 0, 0, 0);
          if (currDate < startDt || currDate > endDt) {
            continue;
          }
        }

        agentAvailableSchedule.push({
          agentStartDate: new Date(Date.parse(`${datePrefix} ${startPrefix}`)),
          agentEndDate: new Date(Date.parse(`${datePrefix} ${endPrefix}`)),
        });
      }
    }
    return agentAvailableSchedule;
  },

  getSchedulingBreakdownAgents: (agents, isNextWeek) => {
    let agentAvailableSchedule = [];
    agents.forEach((agent) => {
      let schedule = schedulingHelpers.getSchedulingBreakdown(agent.workHours, agent.gmtOffset, isNextWeek);
      schedule = schedule.map((x) => ({ ...x, agentId: agent.id }));

      agentAvailableSchedule = agentAvailableSchedule.concat(schedule);
    });

    return agentAvailableSchedule;
  },

  getAgentDayAvailability: (date, user, duration, bookedSchedules, scheduleBreakdown, bufferTime, userOffset) => {
    if (!user.workHours || !user.workHours.data) return null;
    bufferTime = isNaN(bufferTime) ? 0 : bufferTime;

    if (!userOffset) userOffset = dateHelpers.getTimeZoneOffset();
    const datePrefix = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    const nextDatePrefix = dateHelpers.getNextDay(datePrefix);
    const schedules = [];

    // we need to start from the lowest of the schedulebreakdown for the date passed
    let dateArr = scheduleBreakdown.filter(function (el) {
      return el.agentStartDate.getDate() == date.getDate() && el.agentEndDate.getDate() == date.getDate();
    });

    //let start = new Date(Date.parse(`${datePrefix} 12:00 AM`));
    let start = new Date(
      Math.min(
        ...dateArr.map((element) => {
          return new Date(element.agentStartDate);
        })
      )
    );

    if (start == "Invalid Date") start = new Date(Date.parse(`${datePrefix} 12:00 AM`));

    let end = new Date(Date.parse(`${nextDatePrefix} 12:00 AM`));

    do {
      let startTime = new Date(start);
      start.setMinutes(start.getMinutes() + parseInt(duration));
      let endTime = new Date(start);

      if (endTime > end) {
        continue;
      }

      for (const brokenDownSchedule of scheduleBreakdown) {
        let agentStartDateTime = brokenDownSchedule.agentStartDate;
        let agentEndDateTime = brokenDownSchedule.agentEndDate;

        if (
          startTime >= agentStartDateTime &&
          endTime <= agentEndDateTime &&
          !schedules.some((x) => x.startTime === Math.floor(startTime.getTime() / 1000))
        ) {
          const toSetStart = new Date(startTime - Number(user.gmtOffset) * 60 * 60 * 1000 + userOffset * 60 * 60 * 1000);
          const toSetEnd = new Date(endTime - Number(user.gmtOffset) * 60 * 60 * 1000 + userOffset * 60 * 60 * 1000);

          schedules.push({
            startTime: Math.floor(toSetStart.getTime() / 1000),
            endTime: Math.floor(toSetEnd.getTime() / 1000),
            timeString: `${dateHelpers.getTimeString(toSetStart)} - ${dateHelpers.getTimeString(toSetEnd, true)}`,
          });
        }
      }

      start.setMinutes(start.getMinutes() + bufferTime);
    } while (start < end);

    schedules.sort((a, b) => {
      if (a.startTime > b.startTime) return 1;
      if (a.startTime < b.startTime) return -1;
      return 0;
    });

    return schedules;
  },

  getAvailableTimes: (date, user, bookedSchedules, scheduleBreakdown) => {
    const schedule = schedulingHelpers.getAgentDayAvailability(date, user, user.duration, bookedSchedules, scheduleBreakdown);

    return {
      day: date,
      schedules: schedule,
    };
  },

  filterBookedSchedule: (times, bookedSchedules) => {
    const updatedTime = [];

    times.forEach((t) => {
      if (!bookedSchedules.some((x) => x.schedule.startTime <= t.startTime && x.schedule.endTime >= t.endTime)) {
        updatedTime.push(t);
      }
    });

    return updatedTime;
  },

  addBuffertTime: (times, bufferTime, scheduleBreakdown, day) => {
    const updatedTime = [];
    if (times.length === 0) return updatedTime;
    const timeToAdd = bufferTime * 60;
    // if (!scheduleBreakdown.find((x) => x.agentStartDate.getDate() === day.getDate())) return updatedTime;
    // const scheduleStart = scheduleBreakdown.find((x) => x.agentStartDate.getDate() === day.getDate()).agentStartDate;
    // let scheduleEndDate = scheduleBreakdown.find((x) => x.agentStartDate.getDate() === day.getDate()).agentEndDate;

    // if (scheduleEndDate.getDate() > scheduleStart.getDate()) {
    //   scheduleEndDate = new Date(`${scheduleStart.getFullYear()}-${scheduleStart.getMonth() + 1}-${scheduleStart.getDate()} 23:59:59`);
    // }

    updatedTime.push(times[0]);
    for (let i = 1; i < times.length; i++) {
      const time = times[i];
      const startTime = time.startTime + timeToAdd * i;
      const endTime = time.endTime + timeToAdd * i;

      // if (startTime >= scheduleEndDate.getTime() / 1000) {
      //   continue;
      // }

      for (const brokenDownSchedule of scheduleBreakdown) {
        let agentStartDateTime = brokenDownSchedule.agentStartDate;
        let agentEndDateTime = brokenDownSchedule.agentEndDate;

        if (
          startTime >= agentStartDateTime &&
          endTime <= agentEndDateTime &&
          !updatedTime.some((x) => x.startTime === Math.floor(startTime.getTime() / 1000))
        ) {
          updatedTime.push({
            startTime: startTime,
            endTime: endTime,
            timeString: `${dateHelpers.getTimeString(new Date(startTime * 1000))} - ${dateHelpers.getTimeString(new Date(endTime * 1000), true)}`,
          });
        }
      }
    }

    return updatedTime;
  },
  removeCurrentTimesFromSchedule: (times) => {
    const updatedTimes = [];

    times.forEach((t) => {
      if (t.startTime >= new Date().getTime() / 1000) {
        updatedTimes.push(t);
      }
    });

    return updatedTimes;
  },
  getDstTransitionDates:() => {
    var year = new Date().getYear();
    if (year < 1000)
        year += 1900;

    var firstSwitch = 0;
    var secondSwitch = 0;
    var lastOffset = 99;

    var firstOffset = 0;
    var secondOffset = 0;

    // Loop through every month of the current year
    for (let i = 0; i < 12; i++)
    {
        // Fetch the timezone value for the month
        var newDate = new Date(Date.UTC(year, i, 0, 0, 0, 0, 0));
        var tz = -1 * newDate.getTimezoneOffset() / 60;

        // Capture when a timzezone change occurs
        if (tz > lastOffset) {
            firstSwitch = i-1;
            firstOffset = tz;
        }
        else if (tz < lastOffset) {
            secondSwitch = i-1;
            secondOffset = tz;
        }

        lastOffset = tz;
    }

    // Go figure out date/time occurrences a minute before
    // a DST adjustment occurs
    var secondDstDate = schedulingHelpers.findDstSwitchDate(year, secondSwitch);
    var firstDstDate = schedulingHelpers.findDstSwitchDate(year, firstSwitch);

    if (firstDstDate == null && secondDstDate == null)
      return null;
    else {
      const strtDay = parseInt(firstDstDate.split("/")[1]);
      const strtMonth = parseInt(firstDstDate.split("/")[0]) - 1;
      const strtYear = parseInt(firstDstDate.split("/")[2]);
      const strtHour = parseInt(firstDstDate.split(" ")[1].split(":")[0]);
      const strtMinute = parseInt(firstDstDate.split(" ")[1].split(":")[1]);
      const from = new Date(Date.UTC(strtYear, strtMonth, strtDay, strtHour, strtMinute, 0));

      const endDay = parseInt(secondDstDate.split("/")[1]);
      const endMonth = parseInt(secondDstDate.split("/")[0]) - 1;
      const endYear = parseInt(secondDstDate.split("/")[2]);
      const endHour = parseInt(secondDstDate.split(" ")[1].split(":")[0]);
      const endMinute = parseInt(secondDstDate.split(" ")[1].split(":")[1]);
      const to = new Date(Date.UTC(endYear, endMonth, endDay, endHour, endMinute, 0));

      return { start: from, afterStartOffset: firstOffset, end: to, afterEndOffset: secondOffset };
    }
      
  },
  findDstSwitchDate: (year, month) => {
    // Set the starting date
    var baseDate = new Date(Date.UTC(year, month, 0, 0, 0, 0, 0));
    var changeDay = 0;
    var changeMinute = -1;
    var baseOffset = -1 * baseDate.getTimezoneOffset() / 60;
    var dstDate;

    // Loop to find the exact day a timezone adjust occurs
    for (let day = 0; day < 50; day++)
    {
      var tmpDate = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
      var tmpOffset = -1 * tmpDate.getTimezoneOffset() / 60;

      // Check if the timezone changed from one day to the next
      if (tmpOffset !== baseOffset)
      {
        var minutes = 0;
        changeDay = day;

        // Back-up one day and grap the offset
        tmpDate = new Date(Date.UTC(year, month, day-1, 0, 0, 0, 0));
        tmpOffset = -1 * tmpDate.getTimezoneOffset() / 60;

        // Count the minutes until a timezone change occurs
        while (changeMinute === -1)
        {
            tmpDate = new Date(Date.UTC(year, month, day-1, 0, minutes, 0, 0));
            tmpOffset = -1 * tmpDate.getTimezoneOffset() / 60;

            // Determine the exact minute a timezone change
            // occurs
            if (tmpOffset !== baseOffset)
            {
                // Back-up a minute to get the date/time just
                // before a timezone change occurs
                tmpOffset = new Date(Date.UTC(year, month,
                                      day-1, 0, minutes-1, 0, 0));
                changeMinute = minutes;
                break;
            }
            else
                minutes++;
        }

        // Add a month (for display) since JavaScript counts
        // months from 0 to 11
        dstDate = tmpOffset.getMonth() + 1;

        // Pad the month as needed
        if (dstDate < 10) dstDate = "0" + dstDate;

        // Add the day and year
        dstDate += '/' + tmpOffset.getDate() + '/' + year + ' ';

        // Capture the time stamp
        tmpDate = new Date(Date.UTC(year, month,
                            day-1, 0, minutes-1, 0, 0));
        dstDate += tmpDate.toTimeString().split(' ')[0];        
        return dstDate;
      }
    }
  } 
};

export default schedulingHelpers;
